"use client";

import Link from "next/link";

import { SOCIAL_LINKS } from "./social";

const SOCIAL_ICONS: Record<string, React.ReactNode> = {
  X: (
    <svg viewBox="0 0 24 24" className="h-[18px] w-[18px]" fill="currentColor" aria-hidden="true">
      <path d="M18.901 1.153h3.68l-8.04 9.19L24 22.846h-7.406l-5.8-7.584-6.638 7.584H.474l8.6-9.83L0 1.154h7.594l5.243 6.932ZM17.61 20.644h2.039L6.486 3.24H4.298Z" />
    </svg>
  ),
  Telegram: (
    <svg viewBox="0 0 24 24" className="h-[18px] w-[18px]" fill="currentColor" aria-hidden="true">
      <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z" />
    </svg>
  ),
};

export default function Footer() {
  return (
    <footer className="pb-12 pt-16" id="contacts">
      <div className="max-w-[1200px] mx-auto px-6">
        <div className="flex flex-col lg:flex-row items-start justify-between gap-10 mb-20">
          <div className="max-w-[300px] flex flex-col gap-6">
            <Link href="/" className="flex items-center">
              <span className="relative inline-flex items-baseline h-[40px]">
                <span className="text-white text-[26px] font-bold tracking-[-1px] mt-auto">paw</span>
                <img
                  src="/Images/landing/logo-toes.svg"
                  alt=""
                  className="absolute w-[35px] h-[30px] left-[22px] top-0"
                />
                <img
                  src="/Images/landing/logo-white.svg"
                  alt=""
                  className="absolute w-[33px] h-[30px] left-[19px] top-[10px]"
                />
              </span>
              <span className="text-white text-[26px] font-medium tracking-[-1px] mt-auto">
                payments
              </span>
            </Link>
            <p className="text-white/50 text-sm leading-[1.2]">
              Leading cryptocurrency processing solution enabling businesses to
              securely accept digital currency worldwide
            </p>
            <div className="flex items-center gap-3">
              {SOCIAL_LINKS.map((social) => (
                <a
                  key={social.name}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={social.name}
                  className="flex h-9 w-9 items-center justify-center rounded-full bg-white/5 text-white/50 hover:bg-white/10 hover:text-white transition-colors"
                >
                  {SOCIAL_ICONS[social.name]}
                </a>
              ))}
            </div>
          </div>

          <div className="w-full max-w-[672px] flex flex-wrap justify-between gap-6 lg:gap-10">
            <div className="max-w-[181px] w-full">
              <h4 className="text-white text-xl font-medium mb-6">Company</h4>
              <ul className="flex flex-col gap-4">
                <li>
                  <Link
                    href="/docs/terms"
                    className="text-white/35 text-base hover:text-white transition-colors"
                  >
                    Terms of Service
                  </Link>
                </li>
                <li>
                  <Link
                    href="/docs/privacy"
                    className="text-white/35 text-base hover:text-white transition-colors"
                  >
                    Privacy Policy
                  </Link>
                </li>
                <li>
                  <Link
                    href="/docs/aml"
                    className="text-white/35 text-base hover:text-white transition-colors"
                  >
                    AML/KYC Policy
                  </Link>
                </li>
                <li>
                  <Link
                    href="/docs/vdp"
                    className="text-white/35 text-base hover:text-white transition-colors"
                  >
                    Vulnerability Disclosure
                  </Link>
                </li>
                <li>
                  <a
                    href="https://docs.pawpayments.com"
                    target="_blank"
                    rel="noopener"
                    className="text-white/35 text-base hover:text-white transition-colors"
                  >
                    Documentation
                  </a>
                </li>
                <li>
                  <Link
                    href="/blog"
                    className="text-white/35 text-base hover:text-white transition-colors"
                  >
                    Blog
                  </Link>
                </li>
              </ul>
            </div>

            <div className="max-w-[181px] w-full">
              <h4 className="text-white text-xl font-medium mb-6">
                Navigation
              </h4>
              <ul className="flex flex-col gap-4">
                <li>
                  <Link
                    href="#advantages"
                    className="text-white/35 text-base hover:text-white transition-colors"
                  >
                    PawPayments advantages
                  </Link>
                </li>
                <li>
                  <Link
                    href="#conditions"
                    className="text-white/35 text-base hover:text-white transition-colors"
                  >
                    Rates and fees
                  </Link>
                </li>
                <li>
                  <Link
                    href="#methods"
                    className="text-white/35 text-base hover:text-white transition-colors"
                  >
                    Available payment methods
                  </Link>
                </li>
                <li>
                  <Link
                    href="#partners"
                    className="text-white/35 text-base hover:text-white transition-colors"
                  >
                    Partner programme
                  </Link>
                </li>
                <li>
                  <Link
                    href="#faq"
                    className="text-white/35 text-base hover:text-white transition-colors"
                  >
                    FAQ
                  </Link>
                </li>
                <li>
                  <Link
                    href="#"
                    className="text-white/35 text-base hover:text-white transition-colors"
                    onClick={(e) => {
                      e.preventDefault()
                      window.scrollTo({ top: 0, behavior: "smooth" })
                    }}
                  >
                    Go to top
                  </Link>
                </li>
              </ul>
            </div>

            <div className="flex flex-col gap-4 max-w-[210px] w-full">
              <Link
                target="_blank"
                href="mailto:support@pawpayments.com"
                className="flex flex-col hover:opacity-70 transition-opacity"
              >
                <span className="text-white text-lg font-medium leading-[1.5]">
                  support@pawpayments.com
                </span>
                <span className="text-white/35 text-xs">
                  support for merchants
                </span>
              </Link>
              <Link
                target="_blank"
                href="mailto:business@pawpayments.com"
                className="flex flex-col hover:opacity-70 transition-opacity"
              >
                <span className="text-white text-lg font-medium leading-[1.5]">
                  business@pawpayments.com
                </span>
                <span className="text-white/35 text-xs">
                  for business proposals
                </span>
              </Link>
              <Link
                target="_blank"
                href="mailto:legal@pawpayments.com"
                className="flex flex-col hover:opacity-70 transition-opacity"
              >
                <span className="text-white text-lg font-medium leading-[1.5]">
                  legal@pawpayments.com
                </span>
                <span className="text-white/35 text-xs">
                  for authority requests
                </span>
              </Link>
            </div>
          </div>
        </div>

        <div className="flex flex-wrap items-center justify-between gap-5">
          <p className="text-white/30 text-xs leading-[1.5] max-w-[600px]">
            &copy; {new Date().getFullYear()} PawPayments, Inc. — officially
            registered Money Services Business (MSB) with FINTRAC. Attention/Care
            of Office 150, 145 1/2 Church Street, Unit 5, Toronto, Ontario,
            M5B1Y4, Canada.
          </p>
          <div className="flex items-center gap-1.5 flex-wrap text-white/35 text-sm">
            <Link
              href="/docs/privacy"
              className="text-white/35 text-sm hover:text-white transition-colors"
            >
              Privacy Policy
            </Link>
            &bull;
            <Link
              href="/docs/aml"
              className="text-white/35 text-sm hover:text-white transition-colors"
            >
              AML Policy
            </Link>
            &bull;
            <Link
              href="/docs/terms"
              className="text-white/35 text-sm hover:text-white transition-colors"
            >
              Terms of Service
            </Link>
            &bull;
            <Link
              href="/docs/vdp"
              className="text-white/35 text-sm hover:text-white transition-colors"
            >
              VDP
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
